/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BulkImportRowError } from "./BulkImportRowError";
import {
    BulkImportRowErrorFromJSON,
    BulkImportRowErrorFromJSONTyped,
    BulkImportRowErrorToJSON,
} from "./BulkImportRowError";

/**
 *
 * @export
 * @interface BulkImportResult
 */
export interface BulkImportResult {
    /**
     *
     * @type {number}
     * @memberof BulkImportResult
     */
    insertedCount?: number;
    /**
     *
     * @type {Array<BulkImportRowError>}
     * @memberof BulkImportResult
     */
    errors?: Array<BulkImportRowError>;
    /**
     *
     * @type {boolean}
     * @memberof BulkImportResult
     */
    succeeded?: boolean;
}

/**
 * Check if a given object implements the BulkImportResult interface.
 */
export function instanceOfBulkImportResult(
    value: object,
): value is BulkImportResult {
    return true;
}

export function BulkImportResultFromJSON(json: any): BulkImportResult {
    return BulkImportResultFromJSONTyped(json, false);
}

export function BulkImportResultFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): BulkImportResult {
    if (json == null) {
        return json;
    }
    return {
        insertedCount:
            json["insertedCount"] == null ? undefined : json["insertedCount"],
        errors:
            json["errors"] == null
                ? undefined
                : (json["errors"] as Array<any>).map(
                      BulkImportRowErrorFromJSON,
                  ),
        succeeded: json["succeeded"] == null ? undefined : json["succeeded"],
    };
}

export function BulkImportResultToJSON(value?: BulkImportResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        insertedCount: value["insertedCount"],
        errors:
            value["errors"] == null
                ? undefined
                : (value["errors"] as Array<any>).map(BulkImportRowErrorToJSON),
        succeeded: value["succeeded"],
    };
}
